import React from "react";
import "./SecondaryButton.css";

const SecondaryButton = (props) => {
  return (
    <button
      className={
        props.isDisabled ? "secondary-button is-disabled" : "secondary-button"
      }
      onClick={props.onClickFunction}
      disabled={props.isDisabled}
    >
      {props.buttonText}
    </button>
  );
};

export default SecondaryButton;
